
// French
// English
// Spanish
// Deutsch
// Italian

export const region = [    
    {
        "value": "United States",
        "label": "United States"
    },
     {
        "value": "Canada",
        "label": "Canada"
    },
    {
        "value": "Argentina",
        "label": "Argentina"
    },
    {
        "value": "Chile",
        "label": "Chile"
    },
    {
        "value": "Germany",
        "label": "Germany"
    },
    {
        "value": "France",
        "label": "France"
    },
    {
        "value": "Spain",
        "label": "Spain"
    },
    {
        "value": "Italy",
        "label": "Italy"
    }
 
  ]
export const regionLang = {
    "Germany": [
        // {
        //     "value": "de",
        //     "label": "German"
        // },
        {
            "value": "en",
            "label": "English"
        }
    ],
    "France": [
        // {
        //     "value": "fr",
        //     "label": "French"
        // },
        {
            "value": "en",
            "label": "English"
        }
    ],
    "United States": [
      {
            "value": "en",
            "label": "English"
        }
    ],
    "Canada": [
        // {
        //     "value": "fr",
        //     "label": "French"
        // },
        {
            "value": "en",
            "label": "English"
        }
      ],
      "Argentina": [
        {
            "value": "es",
            "label": "Spanish"
        },
        {
            "value": "en",
            "label": "English"
        }
      ],
      "Chile": [
        {
            "value": "es",
            "label": "Spanish"
        },
        {
            "value": "en",
            "label": "English"
        }
      ],
      "Spain": [
        {
            "value": "es",
            "label": "Spanish"
        },
        {
            "value": "en",
            "label": "English"
        }
      ],
      "Italy": [ 
        // {
        //     "value": "it",
        //     "label": "Italian"
        // },
       {
            "value": "es",
            "label": "Spanish"
        },     
        {
            "value": "en",
            "label": "English"
        }
      ],
      
      
      
  } 